
define('template!ordersLabelsEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body">\n  <div class="labels-region"></div>\n</div>\n<div class="footer">\n  <div class="cancel-region"></div>\n  <div class="confirm-region"></div>\n</div>';

}
return __p
};});

